import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import Gray_Btn from "../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Success_Toster from "../../../../../common/common_modal/success_toster/Success_Toster";
import Refresh_btn from "../../../../../common/common_btn/refresh_btn/Refresh_btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import {
  AllRoles,
  AllGender,
} from "../../../../../features/admin/common/Slice";
import { GETAuthLogin } from "../../../../../features/auth/Slice";
import {
  GetNextSerial
} from "../../../../../features/admin/serial_counter/Slice";
import { useDispatch, useSelector } from "react-redux";

const Common_Form = ({
  handleClose,
  showError,
  onSubmit,
  defaultValues,
  success,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues });


  const [showPass, setshowPass] = useState(false);

  const dispatch = useDispatch();
  const roles = useSelector((state) => state.common.all_roles);
  const user = useSelector((state) => state.auth.data);
  const gender = useSelector((state) => state.common.all_gender);
  // const {serialId} = useSelector((state) => state.serial);

  // console.log("serialserialserial",serialId)
  // Fetch roles, gender, user data
  useEffect(() => {
    dispatch(AllGender());
    dispatch(GETAuthLogin());
    dispatch(AllRoles());
    dispatch(GetNextSerial("CHE"));
  }, [dispatch]);

  // Set auto fields like created_by and created_date
  useEffect(() => {
    if (user) setValue("created_by", user.role);
    setValue("created_date", new Date().toISOString().split("T")[0]);
  }, [user, setValue]);

  // Set default values if editing
  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  const [imagePreview, setImagePreview] = useState(null);

  const [localError, setLocalError] = useState({
    email: showError?.email || "",
    contact_no: showError?.contact_no || "",
  });

  const documentSectionRef = useRef(null);



  useEffect(() => {
    if (defaultValues?.role_id && roles?.length > 0) {
      const selectedRole = roles.find(
        (r) => Number(r.value) === Number(defaultValues.role_id),
      );

      if (selectedRole) {
        setValue("role_id", selectedRole);
      }
    }
  }, [roles, defaultValues, setValue]);

  useEffect(() => {
    if (!defaultValues) return;

    reset({
      ...defaultValues,
      status:
        defaultValues.status === true || defaultValues.status === 1 ? "1" : "0",
    });
  }, [defaultValues, reset]);

  useEffect(() => {
    setLocalError({
      email: showError?.email || "",
      contact_no: showError?.contact_no || "",
    });
  }, [showError]);

//   useEffect(() => {
//   if (serialId) {
//     setValue("unique_id", serialId); 
//   }
// }, [serialId, setValue]);

 const togglePassVisibility = () => {
    setshowPass((prevState) => !prevState);
  };


  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <div className="white_container" ref={documentSectionRef}>
        <div className="common_form_div">
          <div className="row">
            {/* Full Name */}
            <div className="col-sm-12">
              <Form.Group className="form_group">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Full Name"
                  {...register("name", { required: "Full name is required" })}
                />
                <Form.Text className="text-danger">
                  {errors?.name?.message || showError?.name}
                </Form.Text>
              </Form.Group>
            </div>

            {/* Chemist ID */}
            <div className="col-sm-6">
               <Form.Group className="form_group">
                <Form.Label>Unique ID</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Unique Id"
                  {...register("unique_id", { required: "Unique Id is required" })}
                />
               <Form.Text className="text-danger">
                  {errors?.unique_id?.message}
                </Form.Text>
                 {showError?.unique_id && (
                  <Form.Text className="text-danger">
                    {showError.unique_id}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Email */}
            <div className="col-sm-6">
              <Form.Group className="form_group">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Email"
                  {...register("email", { required: "Email is required" })}
                  onChange={(e) => {
                    register("email").onChange(e); // keep react-hook-form working
                    setLocalError((prev) => ({ ...prev, email: "" })); // clear backend error
                  }}
                />

                <Form.Text className="text-danger">
                  {errors?.email?.message}
                </Form.Text>
                {showError?.email && (
                  <Form.Text className="text-danger">
                    {showError.email}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Contact */}
            <div className="col-sm-6">
              <Form.Group className="form_group">
                <Form.Label>Contact No</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Contact No"
                  {...register("contact_no", {
                    required: "Contact is required",
                  })}
                  onChange={(e) => {
                    register("contact_no").onChange(e);
                    setLocalError((prev) => ({ ...prev, contact_no: "" }));
                  }}
                />
                <Form.Text className="text-danger">
                  {errors?.contact_no?.message || showError?.contact_no}
                </Form.Text> 
                {showError?.contact && (
                  <Form.Text className="text-danger">
                    {showError.contact}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
             <div className="col-md-12">
                  <Form.Group className="form_group">
                    <Form.Label>Password</Form.Label>

                    <div className="password-field-holder">
                      <Form.Control
                        type={showPass ? "text" : "password"}
                        placeholder="Password"
                        {...register("password", {
                          // required: "Password is required", 
                          minLength: {
                            value: 6,
                            message: "Password must be at least 6 characters",
                          },
                        })}
                      />

                      <div className="eye-icon-holder">
                        <FontAwesomeIcon
                          icon={showPass ? faEyeSlash : faEye}
                          className="eye-icon"
                          onClick={togglePassVisibility}
                        />
                      </div>
                    </div>
                    {errors?.password && (
                      <Form.Text className="text-danger">
                        {errors.password.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

            {/* Gender */}
            <div className="col-sm-5">
              <Form.Label>Gender:</Form.Label>
            </div>
            <div className="col-sm-7">
              <Controller
                name="gender_id"
                control={control}
                rules={{ required: "Gender is required" }}
                render={({ field }) => (
                  <div className="radio_holder">
                    {gender?.map((g) => (
                      <Form.Check
                        key={g.value}
                        inline
                        type="radio"
                        label={g.label}
                        value={g.value}
                        checked={Number(field.value) === Number(g.value)}
                        onChange={() => field.onChange(g.value)}
                      />
                    ))}
                  </div>
                )}
              />
              <Form.Text className="text-danger">
                {errors?.gender_id?.message || showError?.gender_id}
              </Form.Text>
            </div>

            {/* Role */}
            <div className="col-sm-12">
              <Form.Group className="form_group">
                <Form.Label>Role Name</Form.Label>
                <Controller
                  name="role_id"
                  control={control}
                  rules={{ required: "Role is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={roles}
                      getOptionLabel={(e) => e.label}
                      getOptionValue={(e) => e.value}
                    />
                  )}
                />
                <Form.Text className="text-danger">
                  {errors?.role_id?.message || showError?.role_id}
                </Form.Text>
              </Form.Group>
            </div>

            {/* Description */}
            <div className="col-sm-12">
              <Form.Group className="form_group">
                <Form.Label>Role Description (Optional)</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Description"
                  {...register("description")}
                />
              </Form.Group>
            </div>

            {/* Status */}
            <div className="col-sm-6">
              <Form.Label>Current Status:</Form.Label>
            </div>
            <div className="col-sm-6">
              <Controller
                name="status"
                control={control}
                rules={{ required: "Status is required" }}
                render={({ field }) => (
                  <div className="radio_holder">
                    <Form.Check
                      inline
                      type="radio"
                      label="Active"
                      value="1"
                      checked={field.value === "1"}
                      onChange={() => field.onChange("1")}
                      className="green_text"
                    />
                    <Form.Check
                      inline
                      type="radio"
                      label="Inactive"
                      value="0"
                      checked={field.value === "0"}
                      onChange={() => field.onChange("0")}
                      className="red_text"
                    />
                  </div>
                )}
              />
              <Form.Text className="text-danger">
                {errors?.status?.message || showError?.status}
              </Form.Text>
            </div>

            {/* Created By */}
            <div className="col-sm-6">
              <Form.Group className="form_group">
                <Form.Label>Created By (Auto Fetch)</Form.Label>
                <Form.Control
                  type="text"
                  {...register("created_by")}
                  readOnly
                />
              </Form.Group>
            </div>

            {/* Created Date */}
            <div className="col-sm-6">
              <Form.Group className="form_group">
                <Form.Label>Created Date (Auto Fetch)</Form.Label>
                <Form.Control
                  type="date"
                  {...register("created_date")}
                  readOnly
                />
              </Form.Group>
            </div>
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="offcanvas_footer_holder">
          {!success ? (
            <div className="btns_holder">
              <Gray_Btn btnText="Cancel" onClick={handleClose} />
              <Black_Submit_Btn btnText="Submit" type="submit" />
              {/* <Refresh_btn /> */}
            </div>
          ) : (
            <Success_Toster successText="Data saved successfully!" />
          )}
        </div>
      </div>
    </Form>
  );
};

export default Common_Form;
